export default __webpack_public_path__ + "static/media/view1.62ad9f2a.png";